"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
const ui_2 = require("../_components/ui");
const front_1 = require("../../dsl/front");
const Contact_contracts_1 = require("./Contact.contracts");
const ContactForm_1 = require("./_partials/ContactForm");
const ContactLocation_1 = require("./_partials/ContactLocation");
const ContactData_1 = require("./_partials/ContactData");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactModuleUi = class ContactModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        //
        this.TabType = Contact_contracts_1.ContactTabType;
        /**
         * Initial selected tab
         */
        this.activeTabIndex = 'contactForm';
    }
    /**
     * ContactModule tabs , filter canDisplay and return `ContactTabItem`
     */
    get tabs() {
        return [...Object.values(this.module.content.tabs).filter((t) => t.canDisplay).map((tab) => {
                return {
                    label: this.$t(`modules.contact.tabs.${tab.id}.title`),
                    value: tab.id,
                    id: tab.id
                };
            })];
    }
    onSubmit(formData) {
        // Notice! Implement in client side
        return Promise.resolve();
    }
};
ContactModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactModuleUi',
        components: {
            ModuleHeaderUi: ui_2.ModuleHeaderUi,
            BootstrapNav: front_1.BootstrapNav,
            BootstrapImage: front_1.BootstrapImage,
            ContactFormTabUI: ContactForm_1.ContactFormTabUI,
            ContactLocationTabUI: ContactLocation_1.ContactLocationTabUI,
            ContactDataTabUI: ContactData_1.ContactDataTabUI
        },
        template: `
    <section class="contact-module">
      <!-- TMP -->
      <div class="container">
        <div class="row" v-if="module.content.header">
          <div class="col">
            <ModuleHeaderUi :header="module.content.header" />
          </div>
        </div>
        <!-- Tabs -->
        <div class="row" v-if="tabs && tabs.length > 0">
          <div class="col">
            <BootstrapNav :items="tabs" :active-item.sync="activeTabIndex" class="contact__nav"/>

            <div v-for="tab in tabs" :key="tab.id" v-show="activeTabIndex === tab.id" class="contact__tab">
              <div class="container">
                <div class="row">
                  <div class="col">
                    <template v-if="tab.id === TabType.ContactForm">
                      <ContactFormTabUI :onSubmit="onSubmit" :welcomeFormConfig="siteService.getWelcomeFormConfig()" />
                    </template>
                    <template v-if="tab.id === TabType.ContactData">
                      <ContactDataTabUI :items="module.content.tabs[tab.id].content"/>
                    </template>
                    <template v-if="tab.id === TabType.Location">
                      <ContactLocationTabUI :location="module.content.tabs[tab.id].locationUrl"/>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END | TMP -->
    </section>
  `
    })
], ContactModuleUi);
exports.ContactModuleUi = ContactModuleUi;
//# sourceMappingURL=Contact.ui.js.map